import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["form", "title", "hoverable"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CardSupportText, CardTitle, DefaultText, getColor, getSize } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Card, Divider, Tooltip } from 'antd';
import { AudioOutlined, BookOutlined, EditOutlined, FileTextOutlined, UnorderedListOutlined, WechatOutlined } from '@ant-design/icons';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { getFormCoverImageUrl } from '../form-cover-image.utils';
import { getExploreCoverGradient } from './explore-card.gradients';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SKILL_TAG_KEYS = new Set(['Reading', 'Writing', 'Listening', 'Speaking']);
var SKILL_ICONS = {
  Reading: /*#__PURE__*/_jsx(BookOutlined, {}),
  Writing: /*#__PURE__*/_jsx(EditOutlined, {}),
  Listening: /*#__PURE__*/_jsx(AudioOutlined, {}),
  Speaking: /*#__PURE__*/_jsx(WechatOutlined, {})
};
var MAX_VISIBLE_TAGS = 3;
var StyledCard = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 14px;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 2px 8px rgba(28, 30, 32, 0.06);\n  transition:\n    transform 0.22s ease,\n    box-shadow 0.22s ease,\n    border-color 0.22s ease;\n\n  .ant-card-body {\n    padding: 16px 18px 18px !important;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &.ant-card-hoverable:hover {\n    transform: translateY(-3px);\n    border-color: ", ";\n    box-shadow: 0 10px 24px rgba(28, 30, 32, 0.1);\n  }\n"])), getColor('fillIntSubActive'), getColor('fillIntSubHover'));
var StyledCoverWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 152px;\n  overflow: hidden;\n  background: ", ";\n"])), function (props) {
  return props.$hasImage ? '#f3f4f6' : props.$gradient;
});
var StyledCoverImage = styled.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n  filter: brightness(0.95);\n  transition: filter 0.22s ease;\n\n  ", ":hover & {\n    filter: brightness(1);\n  }\n"])), StyledCard);
var TagsWrap = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  right: 12px;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 6px;\n"])));
var CoverPill = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 1px 3px rgba(28, 30, 32, 0.1);\n\n  .anticon {\n    font-size: 11px;\n    flex-shrink: 0;\n  }\n"])));
var CategoryPill = styled(CoverPill)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.9);\n"])), getColor('fillIntActive'));
var SkillPill = styled(CoverPill)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: #c2410c;\n  background: rgba(255, 251, 235, 0.96);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n"])));
var TopicPill = styled(CoverPill)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: #9a3412;\n  background: rgba(255, 237, 213, 0.96);\n  border: 1px solid rgba(251, 146, 60, 0.35);\n"])));
var DefaultPill = styled(CoverPill)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n"])), getColor('textIntSub'));
var OverflowPill = styled(CoverPill)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid rgba(255, 255, 255, 0.85);\n  min-width: 32px;\n  justify-content: center;\n  padding-inline: 8px;\n"])), getColor('textIntSub'));
var StyledBody = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n"])));
var StyledCardTitle = styled(CardTitle)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-bottom: 0 !important;\n\n  span {\n    font-size: ", ";\n    font-weight: 600;\n    line-height: 1.4;\n    color: ", ";\n  }\n"])), getSize('typo14'), getColor('textIntDefault'));
var StyledDivider = styled(Divider)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  margin: 14px 0 10px !important;\n  border-color: ", " !important;\n"])), getColor('fillIntSubActive'));
var StyledMetaRow = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: ", ";\n\n  .anticon {\n    font-size: 13px;\n    color: ", ";\n  }\n"])), getColor('textIntSub'), getColor('textIntSub'));
var StyledMetaText = styled(CardSupportText)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: ", ";\n"])), getSize('typo12'), getColor('textIntSub'));

var truncateLabel = function truncateLabel(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
  return text.length > maxLength ? "".concat(text.slice(0, maxLength), "\u2026") : text;
};

var isSkillTag = function isSkillTag(key) {
  return SKILL_TAG_KEYS.has(key);
};

var ExploreCardCoverTags = function ExploreCardCoverTags(_ref) {
  var _form$tags;

  var form = _ref.form,
      otherLabel = _ref.otherLabel;
  var tags = (_form$tags = form.tags) !== null && _form$tags !== void 0 ? _form$tags : [];
  var visibleTags = tags.slice(0, MAX_VISIBLE_TAGS);
  var overflowCount = tags.length - visibleTags.length;
  var overflowTags = tags.slice(MAX_VISIBLE_TAGS);
  var hasCategory = Boolean(form.category);
  var hasTags = tags.length > 0;
  var hasNoTagOrCategory = !hasCategory && !hasTags;

  var renderTagPill = function renderTagPill(tag) {
    var label = truncateLabel(tag.key, 14);

    if (isSkillTag(tag.key)) {
      var _SKILL_ICONS$tag$key;

      return /*#__PURE__*/_jsx(Tooltip, {
        title: tag.key,
        children: /*#__PURE__*/_jsxs(SkillPill, {
          children: [(_SKILL_ICONS$tag$key = SKILL_ICONS[tag.key]) !== null && _SKILL_ICONS$tag$key !== void 0 ? _SKILL_ICONS$tag$key : /*#__PURE__*/_jsx(FileTextOutlined, {}), /*#__PURE__*/_jsx("span", {
            children: label
          })]
        })
      }, tag.id.toString());
    }

    return /*#__PURE__*/_jsx(Tooltip, {
      title: tag.key,
      children: /*#__PURE__*/_jsxs(TopicPill, {
        children: [/*#__PURE__*/_jsx(FileTextOutlined, {}), /*#__PURE__*/_jsx("span", {
          children: label
        })]
      })
    }, tag.id.toString());
  };

  return /*#__PURE__*/_jsxs(TagsWrap, {
    children: [hasCategory ? /*#__PURE__*/_jsx(Tooltip, {
      title: form.category.key,
      children: /*#__PURE__*/_jsx(CategoryPill, {
        children: truncateLabel(form.category.key, 12)
      })
    }) : null, visibleTags.map(renderTagPill), hasNoTagOrCategory ? /*#__PURE__*/_jsx(DefaultPill, {
      children: otherLabel
    }) : null, overflowCount > 0 ? /*#__PURE__*/_jsx(Tooltip, {
      title: overflowTags.map(function (tag) {
        return tag.key;
      }).join(', '),
      placement: "top",
      children: /*#__PURE__*/_jsxs(OverflowPill, {
        children: ["+", overflowCount]
      })
    }) : null]
  });
};

export var ExploreCard = function ExploreCard(_ref2) {
  var _form$totalQuestions;

  var form = _ref2.form,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? 'Global Form Title' : _ref2$title,
      hoverable = _ref2.hoverable,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var coverGradient = useMemo(function () {
    return getExploreCoverGradient(form.id.toString());
  }, [form.id]);
  var coverImageUrl = useMemo(function () {
    return getFormCoverImageUrl(form);
  }, [form.coverImage, form.thumbnail]);
  var totalQuestions = (_form$totalQuestions = form === null || form === void 0 ? void 0 : form.totalQuestions) !== null && _form$totalQuestions !== void 0 ? _form$totalQuestions : 0;

  var _useState = useState(false),
      hasCoverImageError = _useState[0],
      setHasCoverImageError = _useState[1];

  useEffect(function () {
    setHasCoverImageError(false);
  }, [coverImageUrl, form.id]);
  var shouldShowCoverImage = Boolean(coverImageUrl) && !hasCoverImageError;
  return /*#__PURE__*/_jsx(StyledCard, _objectSpread(_objectSpread({}, rest), {}, {
    hoverable: hoverable,
    cover: /*#__PURE__*/_jsxs(StyledCoverWrapper, {
      $gradient: coverGradient,
      $hasImage: shouldShowCoverImage,
      children: [shouldShowCoverImage ? /*#__PURE__*/_jsx(StyledCoverImage, {
        draggable: false,
        alt: "",
        src: coverImageUrl,
        onError: function onError() {
          return setHasCoverImageError(true);
        }
      }) : null, /*#__PURE__*/_jsx(ExploreCardCoverTags, {
        form: form,
        otherLabel: t('other')
      })]
    }),
    children: /*#__PURE__*/_jsxs(StyledBody, {
      children: [/*#__PURE__*/_jsx(DefaultText, {
        fontWeight: "strong",
        size: "small",
        children: title
      }), /*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/_jsxs(StyledMetaRow, {
        children: [/*#__PURE__*/_jsx(UnorderedListOutlined, {
          "aria-hidden": true
        }), /*#__PURE__*/_jsxs(StyledMetaText, {
          children: [t('totalQuestions'), ": ", totalQuestions]
        })]
      })]
    })
  }));
};